/**************************************************
 * Nombre:       Temas_RG
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import TituloPeqGrande from "../../../Componentes/TituloPeqGrande";
import Tarjeta_Tema from "../../../Tarjetas/Tarjeta_Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Temas_RG = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}}>
                    <TituloPeqGrande peq={'¿De que'} grande={'Hablaremos?'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{mt: sCell ? 6 : 10}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 6 : 8}
                    >

                        {item && item.temas && item.temas.map((tema, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                                    <Tarjeta_Tema tema={tema}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{mt: 10}}>
                    <Typography sx={{fontWeight: 800, fontSize: 24, textAlign: 'center', lineHeight: 1.2}}>No importa si
                        estás empezando
                        o ya tienes tiempo en
                        el mercado: este espacio es para
                        quienes saben que siempre se puede mejorar.
                    </Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Temas_RG


